var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.streamPostRequest}},[_vm._v("Avvia Streaming POST")]),_c('p',[_vm._v("Risposta in streaming:")]),_c('pre',[_vm._v(_vm._s(_vm.streamData))])])}
var staticRenderFns = []

export { render, staticRenderFns }